.mq-detail-list { display: flex; flex-direction: column; gap: var(--mq-space-sm, 12px); min-width: 0; margin: 0; }
.mq-detail-field { display: flex; flex-direction: column; gap: var(--mq-space-xxs, 4px); min-width: 0; }
.mq-detail-field-label, .mq-detail-field-value { min-width: 0; margin: 0; }
.mq-detail-field-value { overflow-wrap: anywhere; }
